export interface IConfiguracaoKDS {
    estacaoKdsUuid: string;
    tempoPreparoSegundos: number;
    usarFireTime?: boolean;
}

export enum StatusItemKDS {
    AGUARDANDO_DISPARO = 'aguardando_disparo',
    AGUARDANDO = 'aguardando',
    EM_PREPARO = 'em_preparo',
    PRONTO = 'pronto',
    CANCELADO = 'cancelado',
    LIBERADO = 'liberado'
}

export type ModoDisparo = 'automatico' | 'manual';
export type TipoKDS = 'completo' | 'simples' | 'desabilitado';

export interface IConfiguracaoEstacaoSimplesKDS {
    estacaoKdsUuid: string;
    categoriaUuids: string[];
    produtoUuids: string[];
}

export interface IConfiguracaoKDSEstabelecimento {
    modoDisparo: ModoDisparo;
    tipoKDS: TipoKDS;
    configuracoesEstacaoSimples?: IConfiguracaoEstacaoSimplesKDS[];
}

export enum StatusKDS {
    PARADO = 'parado',
    EM_ANDAMENTO = 'em_andamento',
    CONCLUIDO = 'concluido',
}

export enum StatusProcessoKDS {
    BLOQUEADO = 'BLOQUEADO',
    DISPONIVEL = 'DISPONIVEL',
    EM_PREPARO = 'EM_PREPARO',
    PRONTO = 'PRONTO',
    CANCELADO = 'CANCELADO',
}

export enum TipoEstacaoKDS {
    PREPARO = 'preparo',
    EXPEDICAO = 'expedicao',
    BEBIDAS = 'bebidas',
    SOBREMESAS = 'sobremesas',
    CUSTOMIZADO = 'customizado'
}

export enum ModoExibicaoKDS {
    LISTA = 'lista',
    CARDS = 'cards',
    COMPACTO = 'compacto'
}

export interface IConfiguracaoExibicaoKDS {
    modoExibicao: ModoExibicaoKDS;
    tempoAlertaAmareloSegundos: number;
    tempoAlertaVermelhoSegundos: number;
    mostrarTempoCorrido: boolean;
    mostrarTempoEstimado: boolean;
    temaEscuro: boolean;
    exibirSomenteItensDaEstacao: boolean;
}

export interface IEstacaoKDS {
    uuid: string;
    estabelecimentoUuid: string;
    nome: string;
    tipo: TipoEstacaoKDS;
    cor: string;
    icone: string;
    ativo: boolean;
    ordemExibicao: number;
    modoExpedicaoArea?: boolean;
    configuracaoExibicao: IConfiguracaoExibicaoKDS;
}

export interface IDetalheProdutoKDS {
    tipo: string;
    descricao: string;
}

export interface IItemPedidoKDS {
    uuid: string;
    pedidoUuid: string;
    numeroPedido?: number;
    estabelecimentoUuid: string;
    itemUuid: string;
    itemTipo?: string;
    itemDescricao?: string;
    detalhesProduto?: IDetalheProdutoKDS[];
    produtoUuid: string;
    produtoDescricao: string;
    processoDescricao?: string;
    quantidade: number;
    observacoes?: string;
    estacaoKdsUuid: string;
    usarFireTime?: boolean;
    aguardaSubitens?: boolean;
    fireTime?: string;
    fireOffsetSegundos?: number;
    anchorSegundos?: number;
    disparadoEm?: string;
    status: StatusItemKDS;
    iniciadoEm?: string;
    concluidoEm?: string;
    tempoEstimadoSegundos: number;
    criadoEm: string;
    tipoPedido?: string;
    /** QR Code por mesa: rodada da conta em que o item foi pedido. */
    rodadaUuid?: string;
    rodadaNumero?: number;
}

export interface IPedidoKDSExpedicao {
    pedidoUuid: string;
    numeroPedido?: number;
    criadoEm?: string;
    itens: IItemPedidoKDS[];
    todosProntos: boolean;
    temDisparo: boolean;    // pedido ainda não foi disparado (aguardando ação manual)
    emDisparo: boolean;     // pedido já foi disparado, itens aparecendo nas estações conforme fire time
    tempoEstimadoTotalSegundos?: number;
    estacoesPorStatus: Record<string, StatusItemKDS>;
    statusKDS?: StatusKDS;
}

// Processo de preparo configurado no produto (ms-produtos)
export interface IProcessoPreparoKDS {
    uuid: string;
    nome: string;
    descricaoExibicao: string;
    estacaoKdsUuid: string;
    tempoPreparoSegundos: number;
    dependeDe: string[]; // UUIDs de outros processos do mesmo produto
    ordem: number;
    usarFireTime?: boolean;
    aguardaTodosSubitens?: boolean;
}

// Instância de processo gerada para um pedido (ms-pedidos)
export interface IProcessoPedidoKDS {
    uuid: string;
    pedidoUuid: string;
    estabelecimentoUuid: string;
    processoPreparoUuid: string;
    nomeProcesso: string;
    descricaoExibicao: string;
    produtoUuid: string;
    produtoDescricao: string;
    quantidade: number;
    observacoes?: string;
    estacaoKdsUuid: string;
    dependeDe: string[]; // UUIDs de outros IProcessoPedidoKDS do mesmo pedido
    status: StatusProcessoKDS;
    disponivelEm?: string;
    iniciadoEm?: string;
    concluidoEm?: string;
    criadoEm: string;
    tempoEstimadoSegundos: number;
}
